import { NotificationFrequency, NotificationMethod } from "@/contexts/auth/enums";

// Local storage keys
export const TOKEN_STORAGE_KEY = 'medihub_auth_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'medihub_refresh_token';
export const USER_STORAGE_KEY = 'medihub_user';

// Available topics for notification preferences
export const AVAILABLE_TOPICS = [
  { id: 'conference', label: 'Konferencia' },
  { id: 'workshop', label: 'Workshop' },
  { id: 'training', label: 'Tréning' },
  { id: 'webinar', label: 'Webinár' },
  { id: 'seminar', label: 'Szeminárium' },
  { id: 'networking', label: 'Networking' },
  { id: 'exhibition', label: 'Kiállítás' },
  { id: 'meetup', label: 'Meetup' },
  { id: 'doctors', label: 'Orvosok' },
  { id: 'nurses', label: 'Ápolók' },
  { id: 'medical_students', label: 'Orvostanhallgatók' },
  { id: 'pharmacists', label: 'Gyógyszerészek' },
  { id: 'healthcare_professionals', label: 'Egészségügyi szakemberek' },
  { id: 'general_public', label: 'Nagyközönség' },
];

// Test dummy user credentials with updated roles
export const TEST_USER = {
  email: 'test@example.com',
  password: 'test123',
  userData: {
    id: 'test-user-id',
    name: {
      firstName: 'Test',
      lastName: 'User'
    },
    email: 'test@example.com',
    role: 'ROLE_MEDIHUB_ORGANIZER',
    contactPhone: '123-456-7890',
    website: 'https://test.com',
    notificationPreferences: {
      frequency: NotificationFrequency.MONTHLY,
      preferredTopics: ['conference', 'workshop', 'doctors'],
      notificationMethod: NotificationMethod.EMAIL,
      enabled: true
    }
  }
};

// Test participant user credentials with updated roles
export const TEST_PARTICIPANT = {
  email: 'participant@example.com',
  password: 'test123',
  userData: {
    id: 'test-participant-id',
    name: {
      firstName: 'Test',
      lastName: 'Participant'
    },
    email: 'participant@example.com',
    role: 'ROLE_MEDIHUB_USER',
    contactPhone: '123-456-7890',
    notificationPreferences: {
      frequency: NotificationFrequency.WEEKLY,
      preferredTopics: ['conference', 'webinar', 'medical_students'],
      notificationMethod: NotificationMethod.EMAIL,
      enabled: true
    }
  }
};
